import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { CiHeart } from "react-icons/ci";

const DiningRestro = ({
  restaurants = [],
  selectedDate,
  selectedTime,
  selectedGuests
}) => {
  const [expandedRestaurants, setExpandedRestaurants] = useState({});

  const normalizedRestaurants = useMemo(() => {
    return restaurants.map((item) => ({
      ...item,
      timeslots: item.timeslots ? JSON.parse(item.timeslots) : [],
      tables: item.tables ? JSON.parse(item.tables) : [],
      offer: item.offer ? JSON.parse(item.offer) : [],
    }));
  }, [restaurants]);

  const toggleTimeSlots = (pkid) => {
    setExpandedRestaurants((prev) => ({
      ...prev,
      [pkid]: !prev[pkid],
    }));
  };

  const formatTime = (time) => {
    if (!time) return "";
    return time.substring(0, 5);
  };

  if (!normalizedRestaurants.length) {
    return <div className="text-center py-5">No restaurants found</div>;
  }

  return (
    <div className="restaurant-list">
      <div className="container">
        <div className="row">
          {normalizedRestaurants.map((item) => {
            const availableSlots =
              item.timeslots?.filter((slot) => slot.IsActive) || [];

            const isExpanded = expandedRestaurants[item.pkid];
            const visibleSlots = isExpanded
              ? availableSlots
              : availableSlots.slice(0, 2);

            const hasMoreSlots = availableSlots.length > 2;

            return (
              <div
                className="col-12 col-md-6 col-lg-3 mt-4"
                key={item.pkid}
              >
                <div
                  className="vertical-product-box product-style-2 h-100"
                  style={{ padding: "0px 0px 10px 0px" }}
                >
                  {/* Image Section */}
                  <div className="vertical-product-box-img">
                    <Link to={`/dining-book/${item.pkid}`}>
                      <img
                        src={`https://highwycombebites.com/documents/${item.bannerImage}`}
                        alt={item.name}
                        className={`product-img-top w-100`}
                        onError={(e) =>
                        (e.target.src =
                          "https://via.placeholder.com/300x200")
                        }
                      />
                    </Link>

                    {/* Wishlist */}
                    <button className="wishlist-close">
                      {item.isfav ? (
                        <i
                          className="fa fa-heart"
                          style={{ color: "red" }}
                        />
                      ) : (
                        <CiHeart />
                      )}
                    </button>
                  </div>

                  {/* Body Section */}
                  {/* <Link to={`/dining-book/${item.pkid}`}> */}
                  <Link
                    to={`/dining-book/${item.pkid}?date=${selectedDate}&time=${selectedTime}&guests=${selectedGuests}`}
                  >
                    <div className="vertical-product-body">
                      <div className="d-flex justify-content-between align-items-center">
                        <h4 className="vertical-product-title">
                          {item.name}
                        </h4>

                        <span
                          style={{
                            background: "#009fe4",
                            color: "#fff",
                            borderRadius: "10px",
                            padding: "3px 8px",
                            fontSize: "14px",
                          }}
                        >
                          ★ {item.avgReview || 0}
                        </span>
                      </div>

                      {/* Location */}
                      <ul className="details-list">
                        <li className="location-text2">
                          <i className="ri-map-pin-fill theme-color" />{" "}
                          {item.location}
                        </li>
                      </ul>

                      {/* Price + Cuisine */}
                      <div className="price-cuisine">
                        <span>£ {item.perHeadCharges}</span>
                        <span className="dot"> • </span>
                        <span>{item.cuisine}</span>
                      </div>

                      {/* Time Slots */}
                      {visibleSlots.length > 0 && (
                        <div className="mt-2 d-flex align-items-center flex-wrap gap-2">
                          {visibleSlots.map((slot) => (
                            <span key={slot.pkid} className="time-slot-stack">
                              <span className="time-text">
                                {formatTime(slot.time)}
                              </span>

                              {item.offer?.length > 0 && (
                                <span className="discount-text">
                                  {item.offer[0].offertext}
                                </span>
                              )}
                            </span>
                          ))}

                          {hasMoreSlots && (
                            <a
                              href={`/dining-book/${item.pkid}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "#c2c2c2",
                                fontSize: "14px",
                                fontWeight: 500,
                                textDecoration: "none",
                              }}
                            >
                              + more
                            </a>
                          )}

                          {item.handicapSeatingCategory === "Fully Accessible" && (
                            <div className="handicap-badge">
                              <img
                                src="/assets/images/handicap.png"
                                alt="Fully Accessible"
                                className="handicap-icon"
                              />
                              <span className="handicap-tooltip">
                                Accessible for Handicap
                              </span>
                            </div>
                          )}
                        </div>
                      )}

                    </div>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div >
  );
};

export default DiningRestro;
